export const currencyToSymbol = currency => {
  switch (currency) {
    case 'EUR':
      return '€'
    case 'NONE':
      return null
    default:
      return '€'
  }
}

export const formatPriceString = ({
  amount = 0,
  locale,
  currencySymbol,
  decimalPlaces = 2,
  symbolRight
}) => {
  const isNegativeAmount = amount < 0
  const displayAmount = Math.abs(amount)
  const price = displayAmount.toLocaleString(locale, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  })

  return symbolRight
    ? `${isNegativeAmount ? '- ' : ''}${price} ${currencySymbol}`
    : `${isNegativeAmount ? '- ' : ''}${currencySymbol} ${price}`
}
